import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import axios from 'axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// 注册全局过滤器
import * as filters from "@/filters/index.js"
const urlObj = require("@/utils/url")
// 引入base-64
// const Base64 = require('js-base64').Base64;
import { toBase64 } from 'js-base64'
let Ui = require('element-ui')
// 为axios添加响应拦截器
import reToken from "@/utils/handelToken"
import Router from 'vue-router'
import "@/assets/css/reset.css"
import utils from "@/utils"
// 引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
// 本地分享
// import NativeShare from './utils/nativeShare'
// var config = {

//   url:window.location.href,

//   title:document.title,

//   desc:'你好阳光',

//   img:'http://shoujibao.net/news/publish/wap/resource/share/v7/img/zd4.png',

//   img_title:'分享',

//   from:'来自AILIHEIHEI'

// };
// var nativeShare = new NativeShare('nativeShare', config)
// Vue.prototype.$Share = nativeShare
// 引入分享插件
import NativeShare from 'nativeshare'
// import { config } from 'vue/types/umd'
// 先创建一个实例
var nativeShare = new NativeShare()
//   wechatConfig: {
//     appId: 'wx7e52abf507f66311',
//     timestamp: new Date(),
//     nonceStr: '',
//     signature: '',
// },
// 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
// 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
// syncDescToTag: false,
// syncIconToTag: false,
// syncTitleToTag: false,


Vue.prototype.$Share = nativeShare

Vue.config.productionTip = false
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
Vue.config.productionTip = false
Vue.use(ElementUI);
// 引入jquery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
// 引入全局组件工具函数
Vue.prototype.$utils = utils
// 将axios封装
Vue.prototype.$http = axios;

// 请求路径封装
axios.defaults.baseURL = process.env.NODE_ENV == "development"
  ? urlObj.devUrl + ''
  : urlObj.proUrl + ''

// 为axios添加拦截器
axios.interceptors.request.use(config => {
  // if (config.url != "/server/api/login/getImageCode") {
  //   // 请求头添加token
  //   config.headers.Authorization = window.localStorage.getItem('token');
  // } else {
  //   delete config.headers.Authorization
  // }
  // q请求拦截器上如果是token时添加basic认证
  if (config.url === '/oauth/token') {
    config.headers.Authorization = `Basic ${toBase64('ICENTER:15a05e79-9d25-4cc9-ba06-658453b0b3f1')}`
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
/* 响应拦截器 */
axios.interceptors.response.use(function (response) {
  if (response.status === 200) {
    if (response.data.code !== 200
      && response.config.url !== '/oauth/token'
      && response.config.url !== '/server/api/statistical/visits/website/search/get'
      && response.config.url !== '/server/api/login/getImageCode'
      && response.config.url.indexOf('/server/api/fileVideo/getVideo') == -1
      && response.config.url.indexOf('/server/api/video/export') == -1
    ) {
      Ui.Message({
        message: response.data.msg,
        type: 'error'
      })
    } else if (response.data.code && response.data.code !== 200 && response.config.url == '/oauth/token') {
      Ui.Message({
        message: response.data.msg,
        type: 'error',
        duration: 2000
      })
    }
    else if (response.data.code == 200
      && response.data.msg !== '查询成功'
      && response.config.url !== '/server/api/user/isUpdate'
    ) {

      Ui.Message({
        message: response.data.msg,
        type: 'success',
        duration: 2000,
      })
    }
  } else {
    return Promise.reject(response)
  }
  return response
}, function (error) {
  if (error || error.response) {
    switch (error.response.status) {
      case 400:
        if (error.response.config.url == '/oauth/token') {
          if (error.response.data.error_description == 'User account is locked') {
            this.$alert('<p style="text-indent: 28px">您好！您的账户已锁定</p>' +
              '<p style="text-indent: 28px">如已“注册”过，请与管理员联系</p>',
              '提示', {
              dangerouslyUseHTMLString: true
            })
          }
          else if (error.response.data.error_description == 'UserDetailsService returned null, which is an interface contract violation') {
            error.message = '账户不存在'
          }
          else if (error.response.data.error_description == 'Bad credentials') {
            error.message = '账户或密码错误'
          } else if (error.request) {
            error.message = '登录失败' + error
          } else {
            error.message = '登录失败' + error
          }
        } else {
          error.message = '请求错误'
        }
        break
      case 401:
        // 如果是非token时401才去获取新的access_token
        if (error.response.config.url !== '/oauth/token') {
          if (error.response.config.url == 'server/api/userRole/getMenu' && error.response.data.error_description == "Full authentication is required to access this resource") {
            return
          } else {
            return reToken(error)
          }
        } else {
          if (error.response.config.url == '/oauth/token' && error.response.data.error_description == "Cannot convert access token to JSON") {
            return
          } else {

            error.message = "账户或密码错误，请重新登陆"
          }
          // error.message = error.response.statusText
        }
        break
      case 403:
        if (error.response.config.url == '/server/api/login/getImageCode'
          || error.response.config.url.indexOf('/server/api/boardingcount/ExcelDownload') !== -1
          || error.response.config.url.indexOf('/server/api/boardingpassengers/importExcel') !== -1

        ) {
          error.response.data.error_description = '拒绝访问，无权限'
        }
        error.message = error.response.data.error_description
        if (error.response.config.url == '/server/api/userRole/getMenu' && error.message == "您的账号在另一台设备上线，您已被迫下线！") {
          setTimeout(() => {
            var uuid = window.localStorage.getItem('uuid')
            window.localStorage.clear();
            window.sessionStorage.clear();
            window.localStorage.setItem('uuid', uuid)
            router.push({
              path: "/hq_w_caac/lgn"
            })
          }, 2000)
        }
        break
      case 404:
        error.message = `请求地址出错: ${error.response.config.url}`
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器内部错误'
        break
      case 501:
        error.message = '服务未实现'
        break
      case 502:
        error.message = '网关错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网关超时'
        break
      case 505:
        error.message = 'HTTP版本不受支持'
        break
      default:
        break
    }
    if (error.message) {
      Ui.Message({
        message: error.message,
        type: 'error'
      })
    }
  }
  return Promise.reject(error)
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
